import { Analytics } from '@plaudit/analytics';
const analytics = Analytics.getInstance();

declare var gatewayExclusions: Array<string>;
/**
 * A simple Gateway Dialog
 */
export default class Gateway {
	public gatewayElement: HTMLElement;
	public anchorElements: NodeList = document.querySelectorAll('a[href^="http"]');
	public clickedElement: HTMLElement;
	public approveButton: HTMLElement;

	private addModal = (event: Event) => {
		let eventTarget = event.currentTarget as HTMLAnchorElement;
		this.clickedElement = eventTarget;

		const href = eventTarget.href.toString();

		gatewayExclusions.unshift(eventTarget.baseURI);
		let exclusionMatches = gatewayExclusions.filter(function(item){
			return href.indexOf(item) !== -1;
		});
		if (exclusionMatches.length === 0) {
			event.preventDefault();
			(this.gatewayElement).classList.add('show');
			this.approveButton.focus();
		}
	}
	private approve() {
		/*GA*/analytics.trackEvent('Exit Notification', 'Click', 'Approve');
		switch (this.clickedElement.getAttribute('target')) {
			case '_blank':
				window.open(this.clickedElement.getAttribute('href'), '_blank').focus();
				break;
			default:
				location.href = this.clickedElement.getAttribute('href');
				break;
		}
	}
	private decline() {
		/*GA*/analytics.trackEvent('Exit Notification', 'Click', 'Decline');
		(this.gatewayElement).classList.remove('show');
	}
	private createModal() {
		let modal = document.createElement('DIALOG');
		modal.setAttribute('id', 'gateway');
		modal.setAttribute('class', 'modal');
		modal.setAttribute('role', 'dialog');
		let sitename = (document.querySelector('meta[property="og:site_name"]') as HTMLMetaElement).content || 'American State Bank';
		modal.innerHTML = `
			<div class="modal__content">
				<div class="modal__header">
					<h2 class="modal__title">You Are About To Leave ${sitename}’s Website</h2>
				</div>
				<div class="modal__body">
					<p>This bank is not responsible for and has no control over the subject matter, content, information or graphics when viewing links attached to this bank’s website. The privacy policy of the site you are about to view may be different than those of ${sitename}.</p>
				</div>
				<div class="modal__footer">
					<button class="btn btn--decline" type="button" data-action="decline"><span>Go Back</span></button>
					<button class="btn btn--approve" type="button" data-action="approve"><span>Continue</span></button>
				</div>
			</div>
			<button class="modal__overlay" type="button" data-action="decline" aria-label="Cancel"><span>Cancel</span></button>
		`;
		document.querySelector('body > footer').appendChild(modal);
		this.createModalEvents();
	}
	private createModalEvents() {
		this.gatewayElement = document.getElementById('gateway');
		const approveButton = (this.gatewayElement).querySelectorAll('button[data-action="approve"]');
		const declineButton = (this.gatewayElement).querySelectorAll('button[data-action="decline"]');

		for (var i = 0; i < approveButton.length; ++i) {
			approveButton[i].addEventListener('click', this.approve.bind(this));
		}
		for (var i = 0; i < declineButton.length; ++i) {
			declineButton[i].addEventListener('click', this.decline.bind(this));
		}
		this.approveButton = (this.gatewayElement).querySelector('button[data-action="approve"]') as HTMLElement;
	}

	constructor() {
		for (var i = 0; i < this.anchorElements.length; i++) {
			this.anchorElements[i].addEventListener('click', this.addModal);
		}
		this.createModal();
	}
}